import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Form,
  Modal,
  Card,
  message,
  Spin,
  Space,
  Image,
  Row,
  Col,
  Divider,
  Empty,
  Tag,
  List,
  Avatar,
  Popconfirm,
  Input,
  Typography,
} from "antd";
import {
  FilePdfOutlined,
  FileSearchOutlined,
  EyeOutlined,
  UploadOutlined,
  DownSquareOutlined,
  UpSquareOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import {
  GET_LOAD_IMAGE_NEW_ALL,
  GET_LOAD_IMAGE_NEW_BY,
  HEADERS_EXPORT_BEN,
  HEADERS_UPIMAGE,
  POST_FLAG_DOC_FIELD_COLLECTION,
  POST_LIST_FIELD_COLLECTION_NOTE,
  POST_INSERT_FIELD_COLLECTION_NOTE,
} from "../../../API/apiUrls";
import { getFileType } from "../../contractDetail/contractDetailNew/utils";
import PdfPreviewModal from "../../contractDetail/contractDetailNew/components/PdfPreviewModal";
import AddImage from "./AddImage";

// ── ประเภทเอกสารที่ต้องเช็คว่ามีอัปโหลดแล้วหรือยัง (docEnforce/docSeize) ──
const ENFORCE_ORDER_DOC = { menuType: 6, imageType: 12 }; // วางคำบังคับ
const SUMMONS_DOC = { menuType: 9, imageType: 16 }; // หมายตั้ง

const hasDocType = (files, docType) =>
  files.some(
    (f) => f.menuType === docType.menuType && f.imageType === docType.imageType,
  );

// ✅ แสดงเฉพาะ menuType/imageType ที่ยังใช้งานจริง (ที่ comment ปิดไว้ = เลิกใช้)
const getDocLabel = (menuType, imageType) => {
  // menuType 5 = คำฟ้อง
  // if (menuType === 5 && imageType === 3)
  //   return { label: "ไฟล์คำฟ้อง", color: "#d46b08" }; // ส้มเข้ม
  // if (menuType === 5 && imageType === 4)
  //   return { label: "ใบเสร็จศาลคำฟ้อง", color: "#d46b08" }; // ส้มเข้ม
  // menuType 6 = ศาลตัดสิน
  if (menuType === 6 && imageType === 7)
    return { label: "คำพิพากษา", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === 6 && imageType === 8)
    return { label: "คำพิพากษา(ทำยอม)", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === 6 && imageType === 9)
    return { label: "ถอนฟ้อง", color: "#096dd9" }; // น้ำเงินเข้ม
  if (
    menuType === ENFORCE_ORDER_DOC.menuType &&
    imageType === ENFORCE_ORDER_DOC.imageType
  )
    return { label: "วางคำบังคับ", color: "#096dd9" }; // น้ำเงินเข้ม
  // if (menuType === 6 && imageType === 10)
  //   return { label: "ใบเสร็จศาลหลังพิพากษา", color: "#389e0d" }; // เขียวเข้ม
  // menuType 8 = ปิดบัญชี
  // if (menuType === 8 && imageType === 13)
  //   return { label: "ใบตัดจ่าย", color: "#096dd9" }; // น้ำเงินเข้ม
  // if (menuType === 8 && imageType === 14)
  //   return { label: "ใบเสร็จปิดบัญชี", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === SUMMONS_DOC.menuType && imageType === SUMMONS_DOC.imageType)
    return { label: "หมายตั้ง", color: "#096dd9" }; // น้ำเงินเข้ม
  // return { label: "เอกสาร", color: "#595959" }; // เทาเข้ม
};

const formatThaiDate = (d) =>
  d ? dayjs(d).add(543, "year").format("DD/MM/YYYY") : "-";

// ── โซนเอกสาร ตรงกับ menuType ที่ loadPath ดึงมา (6, 9) ─────
const ZONE_CONFIG = {
  6: {
    title: "เอกสารชั้นศาล",
    color: "#096dd9",
    bg: "#e6f4ff",
    border: "#91caff",
  },
  9: {
    title: "เอกสารหมายตั้ง",
    color: "#389e0d",
    bg: "#f6ffed",
    border: "#b7eb8f",
  },
};

const { TextArea } = Input;

const UpdateFieldCollectionDoc = ({
  open,
  onCancel,
  dataDefault,
  onSuccess,
}) => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const token = localStorage.getItem("TOKEN");
  // const API_LINE_NOTI =
  //   "https://noti-lawyer-539174983798.asia-southeast1.run.app/api/notify/lawsuit/docs-complete";
  const API_LINE_NOTI =
    "  https://noti-lawyer-1024031113167.asia-southeast3.run.app/api/notify/lawsuit/docs-complete";

  const header = {
    "Content-Type": "application/json",
    "X-API-Key": "your-secret-key-here",
  };

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fileListByContract, setFileListByContract] = useState([]);
  const [pdfPreviewOpen, setPdfPreviewOpen] = useState(false);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState("");
  const [isModalAddImge, setIsModalAddImge] = useState(false);
  const [notes, setNotes] = useState([]);
  const [loadingNotes, setLoadingNotes] = useState(false);
  const [showNotes, setShowNotes] = useState(true);
  const [noteRemark, setNoteRemark] = useState("");

  // ✅ ปิด Modal และ Reset
  const handleClose = useCallback(() => {
    form.resetFields();
    onCancel?.();
  }, [form, onCancel]);

  // ✅ ส่งข้อมูล
  const sendStatus = async (data) => {
    try {
      const res = await axios.post(POST_FLAG_DOC_FIELD_COLLECTION, data, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (res.status === 200) {
        return { success: true, status: res.status };
      } else {
        return { success: false, error: "ไม่สามารถส่งข้อมูลได้" };
      }
    } catch (error) {
      console.error("Error:", error);
      return {
        success: false,
        error:
          error.response?.data?.message || "เกิดข้อผิดพลาดในการอัพเดทข้อมูล",
      };
    }
  };

  const sendNoti = async (hasEnforceCaseDoc, hasSummonsDoc) => {
    let docText;
    if (hasEnforceCaseDoc && hasSummonsDoc) {
      docText = "คำบังคับ,หมายตั้งแล้ว";
    } else if (hasEnforceCaseDoc) {
      docText = "คำบังคับ";
    } else if (hasSummonsDoc) {
      docText = "หมายตั้ง";
    } else {
      return { success: true };
    }

    const payload = {
      case_no: dataDefault.newContno,
      case_name: dataDefault.ownerName,
      notify_to: [1, 48, 49, 50],
      action_by: "ทนาย",
      message: `ทนายอัพเดทเอกสาร${docText} ของเลขคดีแดง ${dataDefault.redCaseNumber}`,
    };

    try {
      const res = await axios.post(API_LINE_NOTI, payload, {
        headers: header,
      });

      if (res.status === 200) {
        message.success("แจ้งเตือนอัพเดทเอกสารสำเร็จ");
        return { success: true, status: res.status };
      } else {
        message.error("ไม่สามารถส่งข้อมูลได้");
        return { success: false, error: "ไม่สามารถส่งข้อมูลได้" };
      }
    } catch (error) {
      console.error("Error:", error);
      const errorMsg =
        error.response?.data?.message || "เกิดข้อผิดพลาดในการอัพเดทข้อมูล";
      message.error(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

  const loadPath = useCallback(async () => {
    setLoading(true);
    try {
      const [imgRes6, imgRes9] = await Promise.all([
        axios.get(`${GET_LOAD_IMAGE_NEW_ALL}/6/${dataDefault.loanId}`, {
          headers: HEADERS_UPIMAGE,
        }),
        axios.get(`${GET_LOAD_IMAGE_NEW_ALL}/9/${dataDefault.loanId}`, {
          headers: HEADERS_UPIMAGE,
        }),
      ]);

      const mapImg = (img) => ({
        ...img,
        CONTNO: dataDefault.contno,
        loanId: dataDefault.loanId,
      });

      const allImages = [
        ...(imgRes6?.data || []).map(mapImg),
        ...(imgRes9?.data || []).map(mapImg),
      ];

      if (allImages.length === 0) {
        message.warning("ไม่พบรูปภาพ");
      }

      setFileListByContract(allImages);
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`เกิดข้อผิดพลาด: ${error.message}`);
      setFileListByContract([]);
    } finally {
      setLoading(false);
    }
  }, [dataDefault]);

  // ✅ โหลดรายการบันทึกภาคสนาม
  const loadNotes = useCallback(
    async (id) => {
      setLoadingNotes(true);
      try {
        const { data } = await axios.post(
          POST_LIST_FIELD_COLLECTION_NOTE,
          {
            id,
            userId,
          },
          {
            headers: HEADERS_EXPORT_BEN,
          },
        );
        setNotes(Array.isArray(data?.data) ? data.data : []);
      } catch (error) {
        if (error.name !== "CanceledError") {
          console.error("Error loadNotes:", error);
        }
        setNotes([]);
      } finally {
        setLoadingNotes(false);
      }
    },
    [userId],
  );

  // ✅ เพิ่มบันทึกภาคสนาม
  const postFieldCollectionNote = async () => {
    if (!noteRemark) {
      message.warning("กรุณากรอกหมายเหตุก่อนบันทึก");
      return;
    }
    setLoadingNotes(true);
    try {
      const res = await axios.post(
        POST_INSERT_FIELD_COLLECTION_NOTE,
        {
          id: dataDefault.id,
          userId,
          note: noteRemark,
        },
        {
          headers: HEADERS_EXPORT_BEN,
        },
      );
      if (res?.status === 200) {
        message.success("บันทึกหมายเหตุสำเร็จ");
        setNoteRemark("");
        await loadNotes(dataDefault.id);
      }
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("Error postFieldCollectionNote:", error);
        message.error("เกิดข้อผิดพลาดในการบันทึกหมายเหตุ");
      }
    } finally {
      setLoadingNotes(false);
    }
  };

  useEffect(() => {
    if (open && dataDefault) {
      loadPath();
      loadNotes(dataDefault.id);
    }
  }, [open, dataDefault, loadPath, loadNotes]);

  // ✅ เรียกใหม่หลังอัปโหลดรูปสำเร็จจาก AddImage
  const handleReload = () => {
    setFileListByContract([]);
    loadPath();
  };

  const onFinish = async (values) => {
    const postData = {
      id: dataDefault.id,
      userId: userId,
      docEnforce: hasEnforceCaseDoc ? 1 : 0,
      docSeize: hasSummonsDoc ? 1 : 0,
    };

    try {
      console.log("postData", postData);

      setLoading(true);

      const result = await sendStatus(postData);

      if (!result.success) {
        throw new Error(result.error);
      }

      sendNoti(hasEnforceCaseDoc, hasSummonsDoc);
      message.success("อัพเดทข้อมูลสำเร็จ");

      setTimeout(() => {
        handleClose();
        onSuccess?.();
      }, 500);
    } catch (error) {
      console.error("❌ เกิดข้อผิดพลาด:", error);
      message.error(error.message || "เกิดข้อผิดพลาดในการบันทึกข้อมูล");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = () => {
    message.error("กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครบ");
  };

  // ✅ แสดงเฉพาะเอกสารที่มี label (ไม่ใช่ประเภทที่ comment ปิดไว้) เรียงตาม menuType → imageType
  const sortedVisibleFiles = [...fileListByContract]
    .filter((file) => getDocLabel(file.menuType, file.imageType))
    .sort((a, b) =>
      a.menuType !== b.menuType
        ? a.menuType - b.menuType
        : a.imageType - b.imageType,
    );

  const zones = Object.keys(ZONE_CONFIG).map((menuType) => ({
    menuType: Number(menuType),
    files: sortedVisibleFiles.filter((f) => f.menuType === Number(menuType)),
  }));

  const hasEnforceCaseDoc = hasDocType(fileListByContract, ENFORCE_ORDER_DOC);
  // ✅ ต้องมีรูปเอกสารหมายตั้ง (menuType 9, imageType 16) ก่อนจึงจะบันทึกได้
  const hasSummonsDoc = hasDocType(fileListByContract, SUMMONS_DOC);

  // ── card รูปภาพ ───────────────────────────────────────────────
  const renderImageCard = (file) => {
    const previewUrl = `${GET_LOAD_IMAGE_NEW_BY}/${file.path}?token=${token}`;
    const { label, color } = getDocLabel(file.menuType, file.imageType);

    return (
      <Col key={file.imageId} xs={8} sm={6} md={4}>
        <div
          style={{
            border: `1px solid ${color}`,
            borderRadius: 8,
            padding: 8,
            textAlign: "center",
            background: "#fff",
          }}
        >
          <Image
            src={previewUrl}
            alt={file.path}
            style={{
              width: "100%",
              height: 80,
              objectFit: "cover",
              borderRadius: 4,
            }}
            preview={{
              mask: (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <EyeOutlined style={{ fontSize: 14 }} />
                  <span style={{ fontSize: 10 }}>ดูรูป</span>
                </div>
              ),
            }}
          />
          <div
            style={{
              marginTop: 6,
              background: color,
              color: "#fff",
              fontSize: 11,
              borderRadius: 4,
              padding: "1px 6px",
              display: "inline-block",
            }}
          >
            {label}
          </div>
        </div>
      </Col>
    );
  };

  // ── card PDF ──────────────────────────────────────────────────
  const renderPdfCard = (file) => {
    const previewUrl = `${GET_LOAD_IMAGE_NEW_BY}/${file.path}?token=${token}`;
    const { label, color } = getDocLabel(file.menuType, file.imageType);
    return (
      <Col key={file.imageId} xs={8} sm={6} md={4}>
        <div
          style={{
            border: `1px solid ${color}`,
            borderRadius: 8,
            padding: 8,
            textAlign: "center",
            background: "#fff",
          }}
        >
          <div
            onClick={() => {
              setPdfPreviewUrl(previewUrl);
              setPdfPreviewOpen(true);
            }}
            style={{
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: 80,
              background: "#fff1f0",
              borderRadius: 6,
              border: "1px dashed #ff4d4f",
              gap: 4,
              transition: "opacity 0.2s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.7")}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
          >
            <FilePdfOutlined style={{ fontSize: 32, color: "#ff4d4f" }} />
            <span style={{ fontSize: 11, color: "#ff4d4f", fontWeight: 500 }}>
              <EyeOutlined style={{ marginRight: 4 }} />
              ดู PDF
            </span>
          </div>
          <div
            style={{
              marginTop: 6,
              background: color,
              color: "#fff",
              fontSize: 11,
              borderRadius: 4,
              padding: "1px 6px",
              display: "inline-block",
            }}
          >
            {label}
          </div>
        </div>
      </Col>
    );
  };

  // ── กล่องโซนเอกสารตาม menuType ─────────────────────────────────
  const renderZone = ({ menuType, files }) => {
    if (!files.length) return null;
    const cfg = ZONE_CONFIG[menuType];
    const pdfFiles = files.filter((f) => getFileType(f.path) === "pdf");
    const imgFiles = files.filter((f) => getFileType(f.path) === "image");

    return (
      <div
        key={menuType}
        style={{
          border: `1px solid ${cfg.border}`,
          borderRadius: 10,
          padding: "12px 16px",
          marginBottom: 16,
          background: cfg.bg,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginBottom: 12,
            paddingBottom: 8,
            borderBottom: `1px solid ${cfg.border}`,
          }}
        >
          <div
            style={{
              background: cfg.color,
              color: "#fff",
              borderRadius: 6,
              padding: "2px 12px",
              fontSize: 14,
              fontWeight: 700,
            }}
          >
            {cfg.title}
          </div>
          <span style={{ fontSize: 14, color: "#888" }}>
            {files.length} ไฟล์
          </span>
        </div>

        {imgFiles.length > 0 && (
          <>
            <div style={{ fontSize: 14, color: "#888", marginBottom: 6 }}>
              รูปภาพ ({imgFiles.length})
            </div>
            <Image.PreviewGroup>
              <Row
                gutter={[8, 8]}
                style={{ marginBottom: pdfFiles.length ? 12 : 0 }}
              >
                {imgFiles.map(renderImageCard)}
              </Row>
            </Image.PreviewGroup>
          </>
        )}

        {pdfFiles.length > 0 && (
          <>
            <div
              style={{
                fontSize: 14,
                color: "#888",
                marginBottom: 6,
                marginTop: imgFiles.length ? 4 : 0,
              }}
            >
              <FilePdfOutlined style={{ color: "#ff4d4f", marginRight: 4 }} />
              เอกสาร PDF ({pdfFiles.length})
            </div>
            <Row gutter={[8, 8]}>{pdfFiles.map(renderPdfCard)}</Row>
          </>
        )}
      </div>
    );
  };

  // ✅ แสดงชื่อเจ้าของสัญญา
  const ownerName = dataDefault
    ? `${dataDefault.newContno || dataDefault.contno || ""} / ${
        dataDefault.ownerName || ""
      }`.trim()
    : "-";

  return (
    <Modal
      title="อัปโหลดเอกสาร"
      open={open}
      onCancel={handleClose}
      width={850}
      footer={null}
      destroyOnHidden
    >
      <Spin spinning={loading} size="large" tip="กำลังบันทึก...">
        <Card>
          <Form
            form={form}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 14 }}
            layout="horizontal"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Form.Item label="เลขสัญญา/เจ้าของสัญญา">
              <span style={{ fontWeight: 500 }}>{ownerName}</span>
            </Form.Item>

            <Form.Item label="หมายเลขคดีแดง">
              {dataDefault?.redCaseNumber}
            </Form.Item>
            <Form.Item label="คำบังคับ">
              <div>
                <Tag color={dataDefault?.enforceCaseDate ? "green" : "default"}>
                  {dataDefault?.enforceCaseDate ? "อัพแล้ว" : "ยังไม่อัพ"}
                </Tag>
                <span style={{ color: "#888" }}>
                  {formatThaiDate(dataDefault?.enforceCaseDate)}
                </span>
              </div>
            </Form.Item>
            <Form.Item label="หมายตั้ง">
              <div>
                <Tag color={dataDefault?.docSeize ? "green" : "default"}>
                  {dataDefault?.docSeize ? "อัพแล้ว" : "ยังไม่อัพ"}
                </Tag>
              </div>
            </Form.Item>
            <Divider orientation="left">
              <Space>
                <Typography.Text
                  strong
                  onClick={() => {
                    setShowNotes(!showNotes);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  บันทึกภาคสนาม
                </Typography.Text>
                <Tag
                  color="blue"
                  onClick={() => {
                    setShowNotes(!showNotes);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {notes.length} รายการ{" "}
                  {!showNotes ? <DownSquareOutlined /> : <UpSquareOutlined />}
                </Tag>
              </Space>
            </Divider>
            {showNotes && (
              <>
                <List
                  style={{
                    marginBottom: 16,
                    borderRadius: 8,
                    overflow: "hidden",
                  }}
                  bordered
                  loading={loadingNotes}
                  dataSource={notes}
                  locale={{ emptyText: "ไม่มีข้อมูลหมายเหตุ" }}
                  renderItem={(item, index) => (
                    <List.Item
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#f0f7ff" : "#ffffff",
                        padding: "12px 16px",
                        alignItems: "flex-start",
                      }}
                    >
                      <List.Item.Meta
                        avatar={
                          <Avatar
                            style={{
                              backgroundColor:
                                index % 2 === 0 ? "#1890ff" : "#096dd9",
                              fontWeight: "bold",
                            }}
                          >
                            {item?.createdByName}
                          </Avatar>
                        }
                        title={
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              flexWrap: "wrap",
                              gap: 4,
                            }}
                          >
                            <Space size={6}>
                              <Typography.Text
                                strong
                                style={{ color: "#1a365d" }}
                              >
                                {item?.createdByName} :
                              </Typography.Text>
                              <Tag
                                color="blue"
                                style={{ borderRadius: 10, fontSize: 11 }}
                              >
                                {dayjs(item?.CreatedAt).format(
                                  "DD/MM/YYYY HH:mm",
                                )}
                              </Tag>
                            </Space>
                            <Typography.Text
                              copyable={{
                                text: `${item?.note}\n ${dayjs(item?.CreatedAt).format("DD/MM/YYYY HH:mm")} [${item?.createdByName}]`,
                                tooltips: ["คัดลอก", "คัดลอกแล้ว!"],
                              }}
                              style={{ fontSize: 12, color: "#888" }}
                            />
                          </div>
                        }
                        description={
                          <Typography.Text
                            style={{
                              fontSize: 13,
                              color: "#333",
                              whiteSpace: "pre-wrap",
                              lineHeight: 1.7,
                            }}
                          >
                            {item?.note}
                          </Typography.Text>
                        }
                      />
                    </List.Item>
                  )}
                />
                <TextArea
                  placeholder="กรอกหมายเหตุ (ถ้ามี)"
                  value={noteRemark}
                  onChange={(e) => setNoteRemark(e.target.value)}
                  rows={5}
                  showCount
                  maxLength={500}
                  style={{ marginBottom: "20px" }}
                />
                <Row>
                  <Col span={24} style={{ textAlign: "center" }}>
                    <Popconfirm
                      placement="topLeft"
                      title="เพิ่มบันทึกภาคสนาม"
                      description="กรุณาตรวจสอบข้อมูลให้เรียบร้อย ไม่สามารถแก้ไขสิ่งที่ได้บันทึกได้!"
                      onConfirm={postFieldCollectionNote}
                      okText="ยืนยัน"
                      cancelText="ปิด"
                      okButtonProps={{ size: "large" }}
                      cancelButtonProps={{ size: "large" }}
                    >
                      <Button
                        type="primary"
                        icon={<SaveOutlined />}
                        disabled={!noteRemark}
                      >
                        บันทึก
                      </Button>
                    </Popconfirm>
                  </Col>
                </Row>
              </>
            )}
            <Divider orientation="left" style={{ marginTop: 24 }}>
              <FileSearchOutlined /> เอกสาร
            </Divider>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: 12,
              }}
            >
              <Button
                icon={<UploadOutlined />}
                type="primary"
                ghost
                onClick={() => setIsModalAddImge(true)}
              >
                อัปโหลดรูป/ไฟล์
              </Button>
            </div>

            {sortedVisibleFiles.length > 0 ? (
              zones.map(renderZone)
            ) : (
              <Empty description="ไม่มีเอกสาร" style={{ margin: "24px 0" }} />
            )}

            <Form.Item style={{ marginTop: 16 }}>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Space size="middle">
                  <Button onClick={handleClose} danger>
                    ยกเลิก
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    disabled={!hasSummonsDoc || dataDefault?.docSeize}
                    title={
                      !hasSummonsDoc
                        ? "กรุณาอัปโหลดรูปเอกสารหมายตั้งก่อนบันทึก"
                        : undefined
                    }
                  >
                    บันทึก
                  </Button>
                </Space>
              </div>
            </Form.Item>
          </Form>
        </Card>
      </Spin>

      <PdfPreviewModal
        open={pdfPreviewOpen}
        url={pdfPreviewUrl}
        onClose={() => {
          setPdfPreviewOpen(false);
          setPdfPreviewUrl("");
        }}
      />

      {isModalAddImge && (
        <AddImage
          open={isModalAddImge}
          close={() => setIsModalAddImge(false)}
          dataDefault={{ judge: [dataDefault] }}
          onSuccess={handleReload}
        />
      )}
    </Modal>
  );
};

export default UpdateFieldCollectionDoc;
